import {
    Box,
    chakra,
    Container,
    Stack,
    Text,
    Image,
    Flex,
    VStack,
    Button,
    Heading,
    SimpleGrid,
    StackDivider,
    useColorModeValue,
    VisuallyHidden,
    List,
    ListItem,
    useToast,
  } from '@chakra-ui/react';
import axios from 'axios';
import { useContext, useEffect } from 'react';
  import { FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
  import { MdLocalShipping } from 'react-icons/md';
  import { Link as RouterLink } from 'react-router-dom';
import { AuthContext } from '../Context/AuthContextProvider';
import { getData } from '../Pages/CartPage';

export default function SingleKidsCard (props) {
      const {authState} = useContext(AuthContext)
    const {id, src,Category, discountPrice,MRP, discount } =props;
    const toast = useToast()

 
  
  const a = () => {
    toast({
      title: 'Product has been added to cart',
      status: 'success',
      duration: 2000,
      isClosable: true,
    })
  }
 
 
 

  const handlePost=   ()=> {
    try {
      return axios({
       method : "post" , 
       url : `https://mock-api-server-2399.onrender.com/cart`,
       data :{ 
         ...props,
       "Quantity" : 1
       }
      }).then(()=>   getData())
    } catch (error) {
      console.log("err") ; 
    }
}

useEffect(() => {
  getData()
}, [ getData ])


    return (
      <Container maxW={'7xl'}>
      <SimpleGrid
        columns={{ base: 1, lg: 2 }}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 18, md: 24 }}>
        <Flex>
          <Image
            rounded={'md'}
            alt={'product image'}
            src={
              src
            }
            fit={'cover'}
            align={'center'} 
            w={'100%'}
            h={{ base: '100%', sm: '800px', lg: '950px' }}
          />
        </Flex>
        <Stack spacing={{ base: 6, md: 10 }}>
          <Box as={'header'}>
            <Heading
              lineHeight={1}
              fontWeight={500}
              fontSize={{ base: '2xl', sm: '4xl', lg: '5xl' }}>
                Kids's Fashion 
            </Heading>
            <Text
              color={useColorModeValue('gray.900', 'gray.400')}
              fontWeight={300}
              fontSize={'2xl'}>
                { `₹ ${ discountPrice}`  }  
                 
            </Text>
            <Text
              color={useColorModeValue('gray.900', 'gray.400')}
              fontWeight={300}
              fontSize={'2xl'}>
               Discount : { `${discount}% Off`}
                 
            </Text>
          </Box>

         
            <VStack spacing={{ base: 4, sm: 6 }}>
              <Text
                color={useColorModeValue('gray.500', 'gray.400')}
                fontSize={'2xl'}
                fontWeight={'300'}>
                Are you looking for a Unique Pattern in Your Wardrobe and Highly Stylized Ethnic Designer Top, then GLAM ROOTS has the Answer for You. This Apparel is Very Stylish and Comfortable With Beautiful Designs and Patterns.
              </Text>
              <Text fontSize={'lg'}>
              Assurance & Authenticity: Quality Satisfaction And Timely Delivery Are Assured. To Be Sure Of Authenticity, We Recommend You To Buy This Product From GLAM ROOTS Brand Only.
              </Text>
            </VStack>

  
 
          <Button
            rounded={'none'}
            w={'full'}
            mt={8}
            size={'lg'}
            py={'7'}
            bg={useColorModeValue('gray.900', 'gray.50')}
            color={useColorModeValue('white', 'gray.900')}
            textTransform={'uppercase'}
            _hover={{
              transform: 'translateY(2px)',
              boxShadow: 'lg',
            }} onClick={()=> {
          handlePost() 
            a()}}>
            Add to cart
          </Button>
     
          <Stack direction="row" alignItems="center" justifyContent={'center'}>
            <MdLocalShipping />
            <Text>2-3 business days delivery</Text>
          </Stack>
        </Stack>
      </SimpleGrid>
    </Container>
    );
  }